import cx from "classnames";
import React from "react";
import Arrow from "./components/IconArrow/IconArrow";
import ArrowLeft from "./components/IconArrowLeft/IconArrowLeft";
import ArrowRight from "./components/IconArrowRight/IconArrowRight";
import ArrowUp from "./components/IconArrowUp/IconArrowUp";
import Back from "./components/IconBack/IconBack";
import BetDrawer from "./components/IconBetDrawer/IconBetDrawer";
import BetDrawerEmpty from "./components/IconBetDrawerEmpty/IconBetDrawerEmpty";
import Bookmark from "./components/IconBookmark/IconBookmark";
import Brokerage from "./components/IconBrokerage/IconBrokerage";
import Check from "./components/IconCheck/IconCheck";
import ChevronDown from "./components/IconChevronDown/IconChevronDown";
import Clock from "./components/IconClock/IconClock";
import Close from "./components/IconClose/IconClose";
import Corner from "./components/IconCorner/IconCorner";
import CornerDesktop from "./components/IconCornerDesktop/IconCornerDesktop";
import Dollar from "./components/IconDollar/IconDollar";
import DollarBlue from "./components/IconDollarBlue/IconDollarBlue";
import EmptyFavorite from "./components/IconEmptyFavorite/IconEmptyFavorite";
import FavIcon from "./components/IconFavIcon/IconFavIcon";
import Favorite from "./components/IconFavorite/IconFavorite";
import FavoriteAlt from "./components/IconFavoriteAlt/IconFavoriteAlt";
import GbFlag from "./components/IconGbFlag/IconGbFlag";
import Graph from "./components/IconGraph/IconGraph";
import Home from "./components/IconHome/IconHome";
import HomeActive from "./components/IconHomeActive/IconHomeActive";
import Lock from "./components/IconLock/IconLock";
import IconLogo from "./components/IconLogo/IconLogo";
import IconLogoEvo from "./components/IconLogoEvo/IconLogoEvo";
import IconLogoGalaxyBet from "./components/IconLogoGalaxyBet/IconLogoGalaxyBet";
import Moon from "./components/IconMoon/IconMoon";
import OpenBets from "./components/IconOpenBets/IconOpenBets";
import Plus from "./components/IconPlus/IconPlus";
import PositionMatrix from "./components/IconPositionMatrix/IconPositionMatrix";
import Profile from "./components/IconProfile/IconProfile";
import Reports from "./components/IconReports/IconReports";
import Search from "./components/IconSearch/IconSearch";
import Session from "./components/IconSessionLogo/IconSessionLogo";
import Settings from "./components/IconSettings/IconSettings";
import Sports from "./components/IconSports/IconSports";
import Statement from "./components/IconStatement/IconStatement";
import Sun from "./components/IconSun/IconSun";
import Trash from "./components/IconTrash/IconTrash";
import "./Icon.scss";

// USAGE

/*
  params:
    (optionals)
    - className: add custom classes to icon
    - isActive: show active version of icon, typically a solid version
    - isPending: show pending version of icon (ONLY IconBrokerage)
    - isLightWhenActive: if the icon should be light color when active
    - currentColor: use the color set on the parent
    - name: name of the sport (ONLY IconSports)

  Icon:
    import { IconHome } from "../components/Icon/Icon";
    <IconHome isLightWhenActive isActive isPending className="custom-class" />
*/
// Icon Wrapper with shared logic
const IconWrapper = (WrappedComponent: any) => {
  type Props = {
    className?: string;
    isActive?: boolean;
    isPending?: boolean;
    isLightWhenActive?: boolean;
    currentColor?: boolean;
    name?: string;
  };
  return class IW extends React.Component<Props> {
    render() {
      const { className, isActive, isLightWhenActive, currentColor, name } =
        this.props;
      return (
        <WrappedComponent
          className={cx(
            "icon",
            {
              "icon--active": isActive,
            },
            {
              "icon--light": isActive && isLightWhenActive,
            },
            {
              "icon--current-color": currentColor,
            },
            className
          )}
          isActive={isActive}
          name={name}
        />
      );
    }
  };
};

// Enhance components
const IconHome: any = IconWrapper(Home);
const IconHomeActive: any = IconWrapper(HomeActive);
const IconEmptyFavorite: any = IconWrapper(EmptyFavorite);
const IconFavorite: any = IconWrapper(Favorite);
const IconFavoriteAlt: any = IconWrapper(FavoriteAlt);
const IconFavIcon: any = IconWrapper(FavIcon);
const IconGbFlag: any = IconWrapper(GbFlag);
const IconProfile: any = IconWrapper(Profile);
const IconReports: any = IconWrapper(Reports);
const IconArrowRight: any = IconWrapper(ArrowRight);
const IconArrowLeft: any = IconWrapper(ArrowLeft);
const IconArrowUp: any = IconWrapper(ArrowUp);
const IconBack: any = IconWrapper(Back);
const IconBookmark: any = IconWrapper(Bookmark);
const IconBrokerage: any = IconWrapper(Brokerage);
const IconClock: any = IconWrapper(Clock);
const IconClose: any = IconWrapper(Close);
const IconDollar: any = IconWrapper(Dollar);
const IconOpenBets: any = IconWrapper(OpenBets);
const IconPlus: any = IconWrapper(Plus);
const IconSearch: any = IconWrapper(Search);
const IconTrash: any = IconWrapper(Trash);
const IconBetDrawer: any = IconWrapper(BetDrawer);
const IconBetDrawerEmpty: any = IconWrapper(BetDrawerEmpty);
const IconCorner: any = IconWrapper(Corner);
const IconCornerDesktop: any = IconWrapper(CornerDesktop);
const IconCheck: any = IconWrapper(Check);
const IconSports: any = IconWrapper(Sports);
const IconSessionLogo: any = IconWrapper(Session);
const IconSettings: any = IconWrapper(Settings);
const IconStatement: any = IconWrapper(Statement);
const IconPositionMatrix: any = IconWrapper(PositionMatrix);
const IconDollarBlue: any = IconWrapper(DollarBlue);
const IconGraph: any = IconWrapper(Graph);
const IconMoon: any = IconWrapper(Moon);
const IconSun: any = IconWrapper(Sun);
const IconArrow: any = IconWrapper(Arrow);
const IconChevronDown: any = IconWrapper(ChevronDown);
const IconLock: any = IconWrapper(Lock);
// Exports the Icons
export {
  IconLogo,
  IconLogoEvo,
  IconLogoGalaxyBet,
  IconHome,
  IconHomeActive,
  IconEmptyFavorite,
  IconFavorite,
  IconFavoriteAlt,
  IconFavIcon,
  IconGbFlag,
  IconProfile,
  IconReports,
  IconArrowRight,
  IconArrowLeft,
  IconArrowUp,
  IconBack,
  IconBookmark,
  IconBrokerage,
  IconClock,
  IconClose,
  IconDollar,
  IconOpenBets,
  IconPlus,
  IconSearch,
  IconTrash,
  IconBetDrawer,
  IconBetDrawerEmpty,
  IconCorner,
  IconCornerDesktop,
  IconCheck,
  IconSports,
  IconSessionLogo,
  IconSettings,
  IconStatement,
  IconPositionMatrix,
  IconDollarBlue,
  IconGraph,
  IconMoon,
  IconSun,
  IconArrow,
  IconChevronDown,
  IconLock,
};
